import './styles/main.scss';
import AppRoutes from './AppRoutes';
import { EmployeeProvider } from './context/EmployeeContext';

function App() {
  return (
    <EmployeeProvider>

    <div className="App">    
    <div className="container-scroller">
        <div className="page-body-wrapper">
          <div className="main-panel">
            <div className="content-wrapper"style={{backgroundColor:"#F8F8F8"}}>
              <AppRoutes />
            </div>
          </div>
        </div>
      </div>
      </div>
      </EmployeeProvider>
  );
}

export default App;





